import externalSlugify from "slugify";

const options = {
  lower: true,
};

export default function slugify(string: string) {
  return externalSlugify(string, options);
}
